news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌×아이헤이트플라잉버그스, AI 기반 온택트 학습 MOU 체결</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌×아이헤이트플라잉버그스, AI&nbsp;기반 온택트 학습 MOU&nbsp;체결</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;에듀윌,&nbsp;전체 사업의 약 60%&nbsp;온라인 기반…&nbsp;디지털 교육 시너지 기대</strong></span>
                              </p>
                              <p><span style="color:black;font-family:'맑은 고딕';"><strong>-&nbsp;에듀윌의 검정고시 및 편입 영어 과목에 ‘IHFB의 AI&nbsp;시스템’&nbsp;적용 방안 논의</strong></span>
                              </p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605140923.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">▲사진 설명:&nbsp;에듀윌 양형남 대표(좌측)와 아이헤이트플라잉버그스 박찬용 대표가 업무협약을 체결하고,&nbsp;기념촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">(2025-04-24) 종합교육기업 에듀윌(대표 양형남)은 지난 22일 서울 구로구 본사에서 에듀테크 기업 아이헤이트플라잉버그스(대표 박찬용,&nbsp;이하 IHFB)와 온택트 학습 혁신 및 인재 양성을 위한 업무협약(MOU)을 체결했다고 24일 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">이번 협약은 에듀윌의 교육 콘텐츠 역량과 IHFB가 개발 중인 AI&nbsp;기술을 결합해 능동적인 학습 관리를 구현하는 것을 목표로 한다. IHFB는 학생의 학습 상황을 실시간으로 분석해 학생이 문제를 인지하기 전에 능동적으로 개입해 필요한 학습 관리를 제공하는 AI&nbsp;시스템을 오는 5월 론칭할 예정이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">양사는 IHFB의 AI&nbsp;시스템을 에듀윌 검정고시 및 편입 영어 과목에 적용하는 방안을 협의할 계획이다.&nbsp;이와 함께 에듀윌 국비교육원과 연계한 코딩 교육 운영도 추진할 예정이다.&nbsp;현재 에듀윌은 전체 사업의 약 60%가 온라인 기반으로 운영될 만큼 디지털 교육 분야에 강점을 보유하고 있어 이번 협업을 통해 실질적인 시너지가 창출될 것으로 기대된다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">이번 협약을 통해 양사는 △AI&nbsp;기반 맞춤형 온택트 교육 콘텐츠 공동 개발 △AI&nbsp;튜터링 기술 기반 학습관리 시스템 구축 및 기술 협력 △브랜드 공동 캠페인 및 고객 대상 프로모션 등에서 긴밀한 협력을 이어갈 예정이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">에듀윌 양형남 대표는 “에듀테크는 에듀윌의 미래 성장동력 중 하나로 이번 협약은 단순 기술 제휴를 넘어 고객 중심의 온택트 학습 경험을 재정의하는 중요한 첫걸음”이라며 “콘텐츠와 기술의 융합을 통해 디지털 교육 시장에서의 경쟁력을 한층 강화하고,&nbsp;학습자 중심의 혁신적인 학습 환경을 만들어 갈 것”이라고 말했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">IHFB&nbsp;박찬용 대표는 "AI&nbsp;기술과 멀티 에이전트 구조를 기반으로 선제적이고 맞춤화된 학습 관리를 구현한 '밀당PT'는 기존 개인화된 학습 관리 방식의 한계를 극복하는 동시에 운영 효율성과 확장성까지 확보한 솔루션"이라며, "에듀윌과의 협력을 통해 더 많은 학습자가 AI&nbsp;기반의 새로운 학습 경험을 누릴 수 있도록 최선을 다하겠다"라고 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">한편,&nbsp;에듀윌은 올해 ‘공진화(Co-evolution)’ 전략을 통해 교육의 디지털 전환과 혁신적인 파트너십 확대에 박차를 가하고 있으며,&nbsp;이번 아이헤이트플라잉버그스와의 협약도 그 일환으로 추진됐다.</span>
                              </p>
                              <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news22" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 넥스트챌린지·넥스트챌린지스쿨과 MOU 체결</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news20" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, HY교육과 '지방소멸 위기 극복' 위한 업무협약 체결</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
